<div class="clock-component center-block">
  <div class="time-block">
    <h1>{{h}}:{{m}}</h1>
    <h1 *ngIf="!onlyTime">{{day}}, {{date}}</h1>
  </div>
</div>
